import { IIconProps } from "../types"

export default function IconLL2(props: IIconProps) {
  const width = props.size || props.width || (88 / 5) * 3
  const height = props.size || props.height || (117 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 88 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.9894 10.5998C86.6495 7.61077 85.4099 6.03128 82.4808 4.7117C79.5618 3.39213 74.9433 2.34246 66.1161 1.5927C57.2889 0.842943 44.2331 0.403084 34.7262 0.453068C25.2192 0.493055 19.2611 1.02289 14.7626 2.07255C10.264 3.13221 7.22497 4.7117 5.14564 7.48082C3.0663 10.2499 1.93666 14.1987 1.2069 19.9968C0.477132 25.8049 0.137241 33.4425 0.817023 47.548C1.48681 61.6535 3.17627 82.2169 5.31558 94.293C7.4449 106.379 10.0341 109.978 13.7529 112.307C17.4617 114.636 22.3001 115.696 27.9783 116.136C33.6565 116.566 40.1844 116.396 45.2428 115.296C50.3112 114.197 53.91 112.177 56.999 109.278C60.098 106.379 62.6872 102.6 66.286 93.7232C69.8849 84.846 74.5034 70.8805 77.9823 58.1346C81.4712 45.3987 83.8304 33.8824 85.2999 25.9349C86.7595 17.9774 87.3193 13.5889 86.9894 10.5998Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
